type Props = {
  size?: number;
  team?: "a" | "b";
  striped?: boolean;
  className?: string;
};

/**
 * Boule — chrome petanque ball. Used in match visuals and start-game coin toss.
 *
 * Server Component with hardcoded defs ids per team variant — SSR/CSR safe.
 * Use the `team` prop to switch between light (team a) and darker (team b).
 */
export function Boule({ size = 36, team = "a", striped = false, className }: Props) {
  const gradId = team === "a" ? "boule-a" : "boule-b";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      className={className}
      style={{ display: "block" }}
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="boule-a" cx="35%" cy="32%" r="70%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="25%" stopColor="#f5f5f5" />
          <stop offset="70%" stopColor="#3a3a3a" />
          <stop offset="100%" stopColor="#0a0a0a" />
        </radialGradient>
        <radialGradient id="boule-b" cx="35%" cy="32%" r="70%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="25%" stopColor="#9d9d9d" />
          <stop offset="70%" stopColor="#3a3a3a" />
          <stop offset="100%" stopColor="#0a0a0a" />
        </radialGradient>
      </defs>
      <ellipse cx="20" cy="36" rx="13" ry="2" fill="#000" opacity="0.5" />
      <circle cx="20" cy="20" r="17" fill={`url(#${gradId})`} />
      <circle
        cx="20"
        cy="20"
        r="17"
        fill="none"
        stroke="#000"
        strokeOpacity="0.3"
        strokeWidth="0.7"
      />
      {striped && (
        <g stroke="#0a0a0a" strokeOpacity="0.55" strokeWidth="0.8" fill="none">
          <path d="M 6 17 Q 20 13 34 17" />
          <path d="M 5 22 Q 20 18 35 22" />
          <path d="M 7 27 Q 20 23 33 27" />
        </g>
      )}
      <ellipse
        cx="14"
        cy="14"
        rx="4"
        ry="2.5"
        fill="#fff"
        opacity="0.7"
        transform="rotate(-25 14 14)"
      />
    </svg>
  );
}
